<div class="tour-backdrop"></div>
<div class="tour-highlight" (click)="tourService.goToNext()" [ngStyle]="highlightStyle">
    <div style="pointer-events: auto; width: 100%; height: 100%;"></div>
</div>
<div class="tour-tooltip" [ngStyle]="tooltipStyle">
  <div class="tour-close-btn" (click)="finishTour()" title="{{ 'TOUR.END_TOUR' | translate }}">
    <ion-icon name="close" color="danger"></ion-icon>
  </div>
  <!-- <span class="tour-step-indicator">{{ tourService.currentStepIndex + 1 }} / {{ tourService.totalSteps }}</span> -->
  <ion-text id="tip-content">{{ content }}</ion-text>
  <ion-toolbar>
    <ion-buttons>
      <ion-button (click)="prev()" [disabled]="!hasPrev">
        <ion-icon name="chevron-back"></ion-icon>
        {{ 'TOUR.PREVIOUS' | translate }}
      </ion-button>
      <ion-button (click)="next()" [disabled]="!hasNext" *ngIf="hasNext">
        {{ 'TOUR.NEXT' | translate }}
        <ion-icon name="chevron-forward"></ion-icon>
      </ion-button>
      <ion-button (click)="finishTour()" *ngIf="!hasNext">
        {{ 'TOUR.END_TOUR' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</div>